import axios from 'axios';

const api = axios.create({
  baseURL: '/api',
  headers: { 'Content-Type': 'application/json' },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('ndf-token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const auth = {
  getConfig: () => api.get('/auth/config'),
  microsoftStart: () => api.get('/auth/microsoft/start'),
  microsoftCallback: (code, state) => api.post('/auth/microsoft/callback', { code, state }),
  getMe: () => api.get('/auth/me'),
};

export const referentiels = {
  charger: () => api.get('/referentiels'),
};

export const depenses = {
  presign: (payload) => api.post('/depenses/presign', payload),
  creer: (payload) => api.post('/depenses', payload),
  brouillon: () => api.get('/depenses/brouillon'),
  lire: (id) => api.get(`/depenses/${id}`),
  modifier: (id, champs) => api.patch(`/depenses/${id}`, champs),
  supprimer: (id) => api.delete(`/depenses/${id}`),
  reanalyser: (id) => api.post(`/depenses/${id}/reanalyser`),
};

export const notes = {
  mes: () => api.get('/notes/mes'),
  soumettre: (dossierId) => api.post('/notes/soumettre', dossierId ? { dossier_id: dossierId } : {}),
  rappeler: (id) => api.post(`/notes/${id}/rappeler`),
  lire: (id) => api.get(`/notes/${id}`),
};

export const dossiers = {
  liste: () => api.get('/dossiers'),
  creer: (libelle) => api.post('/dossiers', { libelle }),
  modifier: (id, champs) => api.patch(`/dossiers/${id}`, champs),
};

export const validation = {
  enAttente: () => api.get('/validation/en-attente'),
  valider: (id, ecartees) => api.post(`/validation/notes/${id}/valider`, { ecartees }),
  refuser: (id, motif) => api.post(`/validation/notes/${id}/refuser`, { motif }),
};

export const compta = {
  notes: (params) => api.get('/compta/notes', { params }),
  transmettre: (id) => api.post(`/compta/notes/${id}/transmettre`),
  rembourser: (id) => api.post(`/compta/notes/${id}/rembourser`),
  exporter: (params) => api.get('/compta/export', { params, responseType: 'blob' }),
  zipJustificatifs: (id) => api.get(`/compta/notes/${id}/justificatifs.zip`, { responseType: 'blob' }),
};

export const admin = {
  habilitations: () => api.get('/admin/habilitations'),
  creerHabilitation: (h) => api.post('/admin/habilitations', h),
  modifierHabilitation: (id, h) => api.patch(`/admin/habilitations/${id}`, h),
  societes: () => api.get('/admin/societes'),
  creerSociete: (s) => api.post('/admin/societes', s),
  modifierSociete: (id, s) => api.patch(`/admin/societes/${id}`, s),
  categories: () => api.get('/admin/categories'),
  creerCategorie: (c) => api.post('/admin/categories', c),
  modifierCategorie: (id, c) => api.patch(`/admin/categories/${id}`, c),
  baremes: () => api.get('/admin/baremes'),
  modifierBareme: (id, taux) => api.patch(`/admin/baremes/${id}`, { taux }),
  journal: () => api.get('/admin/journal'),
};

// Télécharge un blob renvoyé par l'API sous un nom de fichier donné.
export function telechargerBlob(data, nom) {
  const url = URL.createObjectURL(data);
  const a = document.createElement('a');
  a.href = url;
  a.download = nom;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

export default api;
